import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f1e79ef"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "svg-icon",
  src: "/bycsi-root/bybit/deadpool/image-c8ff3d8ca15f460d813dc0378244616f.svg",
  alt: "subscribe"
}, null, -1));
const _hoisted_2 = {
  class: "flex-1"
};
const _hoisted_3 = {
  key: 0,
  class: "icon",
  src: "/bycsi-root/bybit/deadpool/image-c96fb888aa954aa9a4a4c2a79fd8d65b.svg",
  alt: "subscribe-icon"
};
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useSubscribeInfo, subscribe, closeDialog, showDialog, confirmDialog } from '@/hooks/subscribe';
import { saPushEvent } from '@/utils/sensors';
import { noBybitToRegister } from '@/utils/jumpLink';
export default {
  __name: 'SubscribeNew',
  setup(__props) {
    const {
      t
    } = useI18n();
    const store = useStore();
    const isLogin = computed(() => store.state.user.userstate === 1);
    const groupName = 'activity_user';
    const info = useSubscribeInfo(groupName);
    const subClickHandler = () => {
      saPushEvent('SpotLpadHomePageMsgSubscriptionClick', {
        page_name: 'LpadHomePage',
        plate_area: 'Subscribe',
        button_name: info.subscribed ? 'Unsubscribe' : 'Subscribe'
      });
      if (!isLogin.value && noBybitToRegister('spotx_launchpad_ongoing')) {
        return;
      }
      if (info.subscribed) {
        showDialog();
      } else {
        subscribe(groupName);
      }
    };
    const closeDialogHandler = () => {
      closeDialog();
      saPushEvent('SpotLpadHomePageMsgSubscriptionPopUpClick', {
        page_name: 'LpadHomePage',
        plate_area: 'Subscribe',
        button_name: 'Cancel'
      });
    };
    const confirmDialogHandler = () => {
      confirmDialog(groupName);
      saPushEvent('SpotLpadHomePageMsgSubscriptionPopUpClick', {
        page_name: 'LpadHomePage',
        plate_area: 'Subscribe',
        button_name: 'Confirm'
      });
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass([{
          'no-sub': !_unref(info).subscribed
        }, "subscribe-box flex-row flex-items-center"])
      }, [_hoisted_1, _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('lpn_sub_tip_text')), 1), _createVNode(_component_el_button, {
        loading: _unref(info).loading,
        onClick: subClickHandler,
        class: _normalizeClass(_unref(info).subscribed ? 'cancel-btn1' : '')
      }, {
        loading: _withCtx(() => [_createVNode(_component_svg_icon, {
          class: "loading",
          icon: "lp_button_loading"
        })]),
        default: _withCtx(() => [!_unref(info).subscribed && !_unref(info).loading ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(_unref(info).subscribed ? _unref(t)('unsubBtnText') : _unref(t)('subBtnText')), 1)]),
        _: 1
      }, 8, ["loading", "class"])], 2), _createVNode(_component_el_dialog, {
        "model-value": _unref(info).showDialog,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        title: _unref(t)('lpn_unsub_dialog_title'),
        "custom-class": "subscribe-dialog",
        width: "520px",
        top: "20vh"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          class: "dialog-btn cancel-btn",
          onClick: closeDialogHandler
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('lpn_unsub_dialog_cancel')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          class: "dialog-btn confirm-btn",
          onClick: confirmDialogHandler
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('lpn_unsub_dialog_confirm')), 1)]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("p", null, _toDisplayString(_unref(t)('lpn_unsub_dialog_text')), 1)]),
        _: 1
      }, 8, ["model-value", "title"])], 64);
    };
  }
};